export default __webpack_public_path__ + "static/media/navbar-logs-orange.80942d3d.svg";